<button
  type="button"
  class="kb-fab"
  (click)="toggle()"
  [class.kb-fab-open]="open"
  aria-label="Open knowledge base"
>
  {{ open ? '✕' : '?' }}
</button>

<div class="kb-panel" *ngIf="open">
  <div class="kb-panel-header">
    <span>Knowledge base</span>
    <button type="button" class="kb-close" (click)="close()">✕</button>
  </div>

  <input
    type="text"
    class="form-control kb-search"
    placeholder="Search a key or term…"
    [(ngModel)]="search"
    name="kbSearch"
  />

  <div class="kb-body">
    <div class="kb-group" *ngFor="let group of filteredGroups">
      <div class="kb-group-title">{{ group.category }}</div>
      <div class="kb-entry" *ngFor="let entry of group.entries">
        <div class="kb-entry-label">{{ entry.label }}</div>
        <div class="kb-entry-desc">{{ entry.description }}</div>
      </div>
    </div>

    <div class="kb-empty" *ngIf="filteredGroups.length === 0">
      No matching entries.
    </div>
  </div>
</div>

<div class="kb-backdrop" *ngIf="open" (click)="close()"></div>